var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56818 1.74581C8.0375 1.63672 8.518 1.58218 9 1.58331C13.7727 1.58331 16.5 6.99997 16.5 6.99997C16.0861 7.76887 15.5925 8.49276 15.0273 9.15986M10.4455 8.43538C10.2582 8.63495 10.0324 8.79502 9.78147 8.90604C9.53056 9.01706 9.25971 9.07676 8.98506 9.08157C8.71042 9.08638 8.43761 9.03621 8.18292 8.93405C7.92822 8.83189 7.69686 8.67983 7.50262 8.48695C7.30839 8.29406 7.15527 8.0643 7.05239 7.81138C6.94952 7.55845 6.899 7.28754 6.90384 7.0148C6.90869 6.74207 6.9688 6.47309 7.0806 6.22393C7.19239 5.97476 7.35358 5.75051 7.55455 5.56455M2.99984 1L14.9998 13M13.05 11.0218C11.8845 11.9041 10.4653 12.3928 9 12.4166C4.22727 12.4166 1.5 6.99997 1.5 6.99997C2.34811 5.43042 3.52441 4.05913 4.95 2.9781L13.05 11.0218Z",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.88919557dd5fe4482a9ba195f327dc3d.svg";
export { ForwardRef as ReactComponent };